import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { deleteCustomizedEarningById } from "../../graphql/mutations/deleteCustomizedEarningById";
import { paths } from "../../routes/paths";

export const useRewardsActions = () => {
  const navigate = useNavigate();
  const [deleteCustomizedEarning] = useMutation(deleteCustomizedEarningById);
  const handleViewReward = (id) => {
    navigate(`/${paths.rewards}/${paths.customized_reward_details}/${id}`);
  };

  const handleEditReward = (id) => {
    console.log("Edit reward", id);
    // Implement edit functionality
  };

  const handleDeleteReward = (id) => {
    deleteCustomizedEarning({ variables: { id } });
  };

  const getActionButtons = (item) => [
    {
      icon: "visibility",
      onClick: () => handleViewReward(typeof item === "object" ? item.id : item),
      tooltip: "View",
    },
    {
      icon: "edit",
      onClick: () => handleEditReward(item.id),
      tooltip: "Edit",
    },
    {
      icon: "delete",
      onClick: () => handleDeleteReward(item.id),
      tooltip: "Delete",
    },
  ];

  return {
    handleViewReward,
    handleEditReward,
    handleDeleteReward,
    getActionButtons,
  };
};
